
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/wallet-as-a-service",
      function () {
        return require("private-next-pages/products/wallet-as-a-service.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/wallet-as-a-service"])
      });
    }
  